import { render } from "./TagRealms.vue?vue&type=template&id=90db2564&scoped=true"
import script from "./TagRealms.vue?vue&type=script&lang=js"
export * from "./TagRealms.vue?vue&type=script&lang=js"

import "./TagRealms.vue?vue&type=style&index=0&id=90db2564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90db2564"]])

export default __exports__